module.exports = __webpack_public_path__ + "static/media/exercise-ball.e12f6cbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/images/exercise-ball.jpg
// module id = 550
// module chunks = 0